import React, { useEffect, useState } from "react";
import {
	AccordionContainer,
	BlogContainer,
	Cards,
	DropdownContainer,
	GetHelpSection,
	Loader,
	TopicsList,
} from "../../components";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTopicsData, resetTopicsData } from "./store/actions";
import { Helmet } from "react-helmet";
import FontResizeWidget from "../../components/FontResizeWidget";
import { ACCESSIBILITY_FEATURE_ENABLED } from "../../config";
import { parseHelmetTags } from "../../utils/utility";
import { ReactComponent as SearchIcon } from '../../assets/images/svg/searchicon.svg';
const Topics = () => {
	const location = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const subTopicParam = location.subtopics;
	const filterParam = location.filter;

	const [mainContent, setMainContent] = useState();
	const [topicsData, setTopicsData] = useState("");

	const [topicName, setTopicName] = useState();
	const [topicList, setTopicList] = useState([]);
	const [subTopicList, setSubTopicList] = useState([]);
	const [filterVal, setFilterVal] = useState([]);
	const [dropdownVal, setDropDownVal] = useState("");
	const [subTopicSlug, setSubTopicSlug] = useState("");
	const [filteredData, setFilteredData] = useState("");
	const [searchTerm, setSearchTerm] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [pendingAnchorId, setPendingAnchorId] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
	const topicListContent = useSelector((state) => state.topicsDataList);
  console.log("topicListContent", topicListContent);

	const [helmetTag, setHelmetTag] = useState();
	const [titleTag, setTitleTag] = useState();
	const [metaTags, setMetaTags] = useState();

    const generateSuggestions = (searchValue) => {
        if (!searchValue.trim() || !topicsData) return [];

        const normalizedSearch = searchValue.toLowerCase().replace(/\s+/g, '');
        const normalize = (str) => (str).toString().toLowerCase().replace(/\s+/g, '');
        
        const rawResults = Object.entries(topicsData).flatMap(([topicSlug, topicData]) => {
            const topicTitle = topicData.topicTitle || '';
            
            return Object.entries(topicData.subTopics || {}).flatMap(([subTopicSlug, subTopicData]) => {
                const subTopicTitle = subTopicData.subTopicTitle || '';
                const subTopicSummary = subTopicData.subTopicSummary || subTopicData.subTopicSummery || '';
                const matches = [];
                if (
                    normalize(topicTitle).includes(normalizedSearch) ||
                    normalize(subTopicTitle).includes(normalizedSearch) ||
                    normalize(subTopicSummary).includes(normalizedSearch)
                ) {
                    matches.push({
                        type: 'subtopic',
                        mainTitle: subTopicTitle,
                        subTitle: topicTitle,
                        topicTitle,
                        subTopicTitle,
                        description: subTopicSummary,
                        topicSlug,
                        subTopicSlug,
                    });
                }
                
                const contentMatches = (subTopicData.contentBlocks || []).flatMap((block, idx) => {
                    const blockTitle = block.title || '';
                    const blockDesc = block.description || block.summary || block.text || '';
                    const titleHit = normalize(blockTitle).includes(normalizedSearch);
                    const descHit = normalize(blockDesc).includes(normalizedSearch);
                    if (!titleHit && !descHit) return [];
                    return [{
                        type: 'content',
                        mainTitle: blockTitle || 'Content',
                        subTitle: topicTitle,
                        topicTitle,
                        subTopicTitle,
                        description: blockDesc,
                        topicSlug,
                        subTopicSlug,
                        anchorId: `cb-${idx}`,
                    }];
                });
                
                const faqMatches = (subTopicData.faqs || []).flatMap((faq, idx) => {
                    const question = faq.faqQuestion || '';
                    const answer = faq.faqAnswer || faq.answer || '';
                    const questionHit = normalize(question).includes(normalizedSearch);
                    const answerHit = normalize(answer).includes(normalizedSearch);
                    if (!questionHit && !answerHit) return [];
                    return [{
                        type: 'faq',
                        mainTitle: question || 'FAQ',
                        subTitle: topicTitle,
                        topicTitle,
                        subTopicTitle,
                        description: answer,
                        topicSlug,
                        subTopicSlug,
                        anchorId: `faq-${idx}`,
                    }];
                });
                
                return [...matches, ...contentMatches, ...faqMatches];
            });
        });

    
        const uniqueBySubtopic = rawResults.reduce((acc, item) => {
            const key = `${item.topicSlug}__${item.subTopicSlug}`;
            const existing = acc.get(key);
            if (!existing || (item.type === 'subtopic' && existing.type !== 'subtopic')) {
                acc.set(key, item);
            }
            return acc;
        }, new Map());

        return Array.from(uniqueBySubtopic.values()).slice(0, 10);
    };

	useEffect(() => {
		dispatch(fetchTopicsData());
	}, []);

	useEffect(() => {
		if (topicListContent.isSuccess && topicListContent.data !== null) {
			setMainContent(topicListContent.data);
			dispatch(resetTopicsData());
		} else if (topicListContent.isError) {
			dispatch(resetTopicsData());
		}
	}, [topicListContent]);

	useEffect(() => {
		if (
			topicListContent.isSuccess &&
			mainContent !== undefined &&
			mainContent?.success?.data && !Array.isArray(mainContent.success.data)
		) {
			setTopicsData(mainContent?.success.data);
			formatTopicsData(mainContent?.success.data);
		}
	}, [mainContent]);

    useEffect(() => {
        if (topicsData && subTopicParam) {
            formatTopicsData(topicsData);
        }
    }, [subTopicParam, filterParam, topicsData]);

const formatTopicsData = (data) => {
  if (!data || typeof data !== "object") return;

  const topicFullData = data;
  const topicKeys = Object.keys(topicFullData);
//   console.log("Topic full data search:-", topicFullData, searchTerm);

  // 🧩 Build the new topic list first (no intermediate setState)
  const newTopicList = topicKeys.map((topicSlug) => ({
    title: topicFullData[topicSlug]?.topicTitle || "Untitled",
    slug: topicSlug,
  }));

        const updateTopicList = () => {
            setTopicList(newTopicList);
        };

        const navigateToTopic = (subTopicParam, filterParam, subTopicData) => {
            if (!subTopicData || Object.keys(subTopicData).length === 0) return;

    if (filterParam) {
      setDropDownVal(subTopicData[filterParam].subTopicTitle);
      setFilteredData(subTopicData[filterParam]);
      setSubTopicSlug(filterParam);
      setHelmetTag(subTopicData[filterParam].seoMetaTags);
      navigate(`/topics/${subTopicParam}/${filterParam}`);
    } else {
      const firstSubKey = Object.keys(subTopicData)[0];
      const firstSub = subTopicData[firstSubKey];
      setDropDownVal(firstSub.subTopicTitle);
      setFilteredData(firstSub);
      setSubTopicSlug(firstSubKey);
      setHelmetTag(firstSub.seoMetaTags);
      navigate(`/topics/${subTopicParam}/${firstSubKey}`);
    }
  };

  // ✅ Main update logic
  if (
    topicKeys.includes(subTopicParam) &&
    topicFullData[subTopicParam] !== undefined &&
    Object.keys(topicFullData[subTopicParam].subTopics || {}).length > 0
  ) {
    updateTopicList();

    for (const topicSlug of topicKeys) {
      const subTopicData = topicFullData[topicSlug]?.subTopics || {};
      if (topicSlug === subTopicParam) {
        setSubTopicList(subTopicData);
        setTopicName(topicFullData[topicSlug]?.topicTitle);
        navigateToTopic(subTopicParam, filterParam, subTopicData);
      }
    }
  } else {
    updateTopicList();

    // Set the first topic as default
    const firstKey = topicKeys[0];
    const firstTopic = topicFullData[firstKey];
    const firstSubTopics = firstTopic?.subTopics || {};

    if (firstTopic && Object.keys(firstSubTopics).length > 0) {
      setTopicName(firstTopic.topicTitle);
      setSubTopicList(firstSubTopics);
      const firstSubKey = Object.keys(firstSubTopics)[0];
      const firstSub = firstSubTopics[firstSubKey];
      setDropDownVal(firstSub.subTopicTitle);
      setFilteredData(firstSub);
      setSubTopicSlug(firstSubKey);
      setHelmetTag(firstSub.seoMetaTags);
      navigate(`/topics/${firstKey}/${firstSubKey}`);
    }
  }
};


	const onTopicChange = (topic, slug) => {
		setTopicName(topic);
		setFilterVal([]);
		// console.log("Topic changed to:", topic, "with slug:", slug);
		for (const listData in topicsData) {
			// console.log("Checking topic slug:", listData);
			if (slug === listData) {
				let subTopicData = topicsData[listData].subTopics;
				// console.log("Subtopic data for selected topic:", subTopicData);
				setSubTopicList(subTopicData);
				setDropDownVal(Object.values(subTopicData)[0].subTopicTitle);
				setSubTopicSlug(Object.keys(subTopicData)[0]);
				setFilteredData(Object.values(subTopicData)[0]);

				setHelmetTag(subTopicData[Object.keys(subTopicData)[0]].seoMetaTags);

				navigate(`/topics/${slug}/${Object.keys(subTopicData)[0]}`);
			}
		}
	};

    useEffect(() => {
        if (!subTopicList) {
            setFilterVal([]);
            return;
        }

        const rebuiltOptions = Object.keys(subTopicList).map((key) => (
            {
                id: key,
                value: subTopicList[key]?.subTopicTitle,
            }
        ));

        setFilterVal(rebuiltOptions);
    }, [subTopicList]);

	const onDropDownClick = (val) => {
		setDropDownVal(val);
		for (let subTopicSlug in subTopicList) {
			if (subTopicList[subTopicSlug].subTopicTitle === val) {
				setFilteredData(subTopicList[subTopicSlug]);

				setHelmetTag(subTopicList[subTopicSlug].seoMetaTags);

				navigate(`/topics/${subTopicParam}/${subTopicSlug}`);
			}
		}
	};

    useEffect(() => {
        if (helmetTag !== '') {
            const { titleTag, metaTags } = parseHelmetTags(helmetTag);
            setTitleTag(titleTag);
            setMetaTags(metaTags);
        }
    }, [helmetTag]);

    useEffect(() => {
        if (searchTerm.trim() && topicsData) {
            const results = generateSuggestions(searchTerm);
            setSuggestions(results);
            setShowSuggestions(results.length > 0);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    }, [searchTerm, topicsData]);

  
    const onSelectSuggestion = (item) => {
        setShowSuggestions(false);
        setShowSearchBar(false);
        setSearchTerm("");
        if (item.anchorId) {
            setPendingAnchorId(item.anchorId);
        } else {
            setPendingAnchorId("");
        }
        navigate(`/topics/${item.topicSlug}/${item.subTopicSlug}`);
    };

    // Auto-scroll to content after navigation
    useEffect(() => {
        if (!pendingAnchorId) return;
        
        const timer = setTimeout(() => {
            const element = document.getElementById(pendingAnchorId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
                setPendingAnchorId("");
            }
        }, 300);
        
        return () => clearTimeout(timer);
    }, [filteredData, pendingAnchorId]);

    const handleSearchIconClick = () => {
        setShowSearchBar(true);
        setTimeout(() => {
            const searchInput = document.querySelector('.faq-search-input');
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    };

    const closeSearchBar = () => {
        setShowSearchBar(false);
        setSearchTerm('');
        setShowSuggestions(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showSearchBar) {
                const searchWrapper = document.querySelector('.search-input-wrapper');
                const searchIcon = document.querySelector('.topic-list-search-icon');
                if (searchWrapper && !searchWrapper.contains(event.target) &&
                    searchIcon && !searchIcon.contains(event.target)) {
                    closeSearchBar();
                }
            }
        };

        if (showSearchBar) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSearchBar]);

    return (
      <div>
        {ACCESSIBILITY_FEATURE_ENABLED ? (
          <FontResizeWidget
            minSize={14}
            maxSize={32}
            step={2}
            defaultSize={16}
          />
        ) : null}

        {helmetTag !== "" ? (
          <Helmet>
            {titleTag} {metaTags}
          </Helmet>
        ) : (
          <Helmet>
            <title>{`${
              topicName ? topicName + " | " : ""
            }Topics | My Housing Gateway Static`}</title>
          </Helmet>
        )}
        {topicListContent.isFetching ? (
          <Loader message={"Loading....."} />
        ) : topicListContent.isSuccess &&
          mainContent !== undefined &&
          !Array.isArray(mainContent?.success.data) ? (
          <div className="topics">
            <TopicsList
              topicListData={topicList}
              title={topicName}
              onTopicChange={onTopicChange}
              filterSlug={subTopicSlug}
              onSearchIconClick={handleSearchIconClick}
              isSearchActive={showSearchBar}
            />
            <div>
              <div className="bg-white py-3 py-md-5 position-relative topic-blog-container">
                <div className="container">
                  <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
                    <h1 className="topic-title textBlue text-title-24 mb-3 mb-md-0" >
                      {topicName}
                    </h1>
                    <div className="col-12 col-md-8">
                      {showSearchBar && (
                        <div className="search-container">
                          <div className="search-input-wrapper">
                              <div className="search-bar-row">
                              <SearchIcon
                                className="search-icon topic-list-search-icon"
                                aria-hidden="true"
                                style={{
                                  color: isInputFocused ? '#00DD98' : '#7E7E7E',
                                  width: 22,
                                  height: 22,
                                }}
                              />
                              <input
                                type="text"
                                className="form-control shadow-none faq-search-input"
                                placeholder="Search by keyword"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onFocus={() => setIsInputFocused(true)}
                                onBlur={() =>
                                  setTimeout(
                                    () => setIsInputFocused(false),
                                    200
                                  )
                                }
                              />
                              {searchTerm && (
                                <button
                                  type="button"
                                  className="search-clear-btn"
                                  onClick={() => setSearchTerm("")}
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                            {showSuggestions && suggestions.length > 0 && (
                              <>
                                <div className="suggestions-header">
                                  <span className="result-count">
                                    {suggestions.length}
                                  </span>
                                  <span className="result-label">
                                    {" "}
                                    result{suggestions.length !== 1
                                      ? "s"
                                      : ""}{" "}
                                    for{" "}
                                  </span>
                                  <strong className="result-term">
                                    {searchTerm}
                                  </strong>
                                </div>
                                {suggestions.map((sug, idx) => (
                                  <div
                                    key={`${sug.type}-${idx}`}
                                    className="suggestion-item"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => onSelectSuggestion(sug)}
                                  >
                                    <div className="suggestion-content">
                                      <div className="suggestion-left">
                                        <div className="suggestion-main-title">
                                          {sug.topicTitle || sug.subTitle || ""}
                                        </div>
                                        {sug.subTopicTitle && (
                                          <div className="suggestion-sub-title">
                                            {sug.subTopicTitle}
                                          </div>
                                        )}
                                      </div>
                                      <div className="suggestion-right">
                                        {" "}
                                        <i className="bi bi-chevron-right suggestion-arrow" />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                                        {searchTerm.trim() && !showSuggestions && (
                                            <div className="suggestions-empty" style={{ padding: 10, textAlign: 'center' }}>No results found</div>
                                        )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {filteredData !== null && filteredData !== "" && (
                    <DropdownContainer
                      title={
                        <span style={{ 
                          fontFamily: 'Inter', 
                          color: '#3B3B3B', 
                          fontWeight: 400 ,
                          fontSize: '18px'
                        }}>
                          I want to read information on this topic relating to
                        </span>
                      }
                      color={"lightBlue"}
                      dropdownvalue={dropdownVal}
                      options={filterVal}
                      onDropDownChange={onDropDownClick}
                    />
                  )}
                  {filteredData?.subTopicSummary ||
                  filteredData?.subTopicSummery ? (
                    <p
                      className="mt-custom text-16 topic-summary-text"
                  
                    >
                      {filteredData?.subTopicSummary ||
                        filteredData?.subTopicSummery}
                    </p>
                  ) : null}
                </div>
                <div className="container">
                  {Array.isArray(filteredData?.contentBlocks) &&
                  filteredData?.contentBlocks ? (
                    <div>
                      {(filteredData?.contentBlocks || []).map(
                        (blogItem, idx) => {
                          return (
                            <BlogContainer
                              key={idx}
                              blogItem={blogItem}
                              anchorId={`cb-${idx}`}
                            />
                          );
                        }
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
              {Array.isArray(filteredData?.caseStudies) &&
              filteredData.caseStudies.length ? (
                <div className="maincase-card">
                <div className="bg-cream case-card">
                  <div className="container">
                    {filteredData?.caseStudies ? (
                      <h3 className="text-title-26">
                        Case studies from private tenants
                      </h3>
                    ) : null}
                    {filteredData?.caseStudies ? (
                      <ul className="card-container d-flex flex-column flex-wrap flex-md-row justify-content-between case-list-container">
                        {filteredData?.caseStudies.map((caseItem, idx) => {
                          return (
                            <Cards
                              type="case"
                              title={`${caseItem?.caseStudyName}, ${caseItem?.caseStudyLocation}`}
                              description={caseItem?.caseStudyTestimonial}
                            />
                          );
                        })}
                      </ul>
                    ) : null}
                  </div>
                </div>
                </div>
              ) : null}
               {/* * change the content block to the fansq
               {filteredData?.contentBlocks ? (
                     <div className="bg-white py-4 py-md-5">
                       <div className="container">
                         <h3 className="text-title-28 mb-4">General Information</h3>
                         <div className="accordion-list-container">
                           <AccordionContainer
                             list={filteredData?.contentBlocks.map((item, idx) => ({
                               faqQuestion: item.title,
                               faqResponse: item.description
                             }))}
                             accordionClicked={() => {}}
                           />
                         </div>
                       </div>
                     </div>
                   ) : null}
               */}
              {Array.isArray(filteredData?.faqs) &&
              filteredData?.faqs.length ? (
                <div className="bg-white topic-faq">
                  <div className="container">
                    {filteredData?.faqs ? (
                      <div>
                        <h3 className="text-title-28 faq-title">
                          Frequently asked questions
                        </h3>
                        <AccordionContainer
                          list={filteredData?.faqs}
                          accordionClicked={() => {}}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {filteredData?.externalSites &&
              mainContent !== undefined &&
              filteredData?.externalSites.length > 0 ? (
                <div>
                  <GetHelpSection
                    title="Where can I get further information?"
                    description={filteredData?.furtherInfo}
                    list={filteredData?.externalSites}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : topicListContent?.isSuccess &&
          Array.isArray(mainContent?.success.data) ? (
          <div className="container">
            <p className="text-24 mt-4">No data found</p>
          </div>
        ) : null}
      </div>
    );
};

export default Topics;
